"use strict";

exports.__esModule = true;
exports.canSubscribeToRealtime = canSubscribeToRealtime;
function canSubscribeToRealtime(workdayInterval, shiftInterval, selectedInterval) {
  var workdayStartMillis = workdayInterval.startMillis,
    workdayEndMillis = workdayInterval.endMillis;
  var shiftStartMillis = shiftInterval.startMillis,
    shiftEndMillis = shiftInterval.endMillis;
  var selectedStartMillis = selectedInterval.startMillis,
    selectedEndMillis = selectedInterval.endMillis;
  var isSelectionSameAsWorkday = workdayStartMillis === selectedStartMillis && workdayEndMillis === selectedEndMillis;
  var isSelectionSameAsShift = shiftStartMillis === selectedStartMillis && shiftEndMillis === selectedEndMillis;
  return isSelectionSameAsWorkday || isSelectionSameAsShift;
}